import { action, makeObservable, observable } from 'mobx';
import { getProfileAPI } from '../Pages/Wallet/Service/api';
import { pageBackgroundConstants, StatusCode } from '../Constants/Constants';
import { IMSAProfile } from '@mojang/stores-provider';
import { IGlobalStore } from '../Utils/Interfaces/Utils.interface';
import { RefObject } from 'react';

class GlobalStore implements IGlobalStore {
  public profileID: string;
  public profileName: string;
  public hasProfileId: boolean;
  public profileDetials: IMSAProfile;
  public error: boolean;

  public showErrorComp: boolean;
  public isBreadcrumbVisible: boolean = true;
  public reloadToMygames: boolean;
  public apiFailureToastMessage: string;
  public changesSavedToastMessage: string;

  public showbackgroundColor: pageBackgroundConstants;
  public closeAlt: string;

  public globalDropdownRef: RefObject<HTMLInputElement>;
  public playFabAuthURL: string;

  constructor() {
    makeObservable(this, {
      profileID: observable,
      profileName: observable,
      hasProfileId: observable,
      profileDetials: observable,
      error: observable,
      showErrorComp: observable,
      isBreadcrumbVisible: observable,
      reloadToMygames: observable,
      apiFailureToastMessage: observable,
      changesSavedToastMessage: observable,
      showbackgroundColor: observable,
      closeAlt: observable,
      globalDropdownRef: observable,
      playFabAuthURL: observable,
      showBreadcrumbs: action,
      hideBreadcrumbs: action,
      clearError: action,
      setError: action,
      setBackgroundColor: action
    });
  }

  getProfileDetails = async () => {
    const { data, error } = await getProfileAPI();

    if (error) {
      this.error = error;
    }

    if (error && data.status === StatusCode.NotFound) {
      this.hasProfileId = false;
    }

    if (!error && data) {
      this.profileDetials = data;
      this.profileID = data?.id;
      this.profileName = data?.name;
      this.hasProfileId = true;
      this.error = false;
    }
  };

  clearError() {
    this.showErrorComp = false;
  }

  setError() {
    this.showErrorComp = true;
  }

  hideBreadcrumbs() {
    this.isBreadcrumbVisible = false;
  }

  showBreadcrumbs() {
    this.isBreadcrumbVisible = true;
  }

  setBackgroundColor(color: pageBackgroundConstants) {
    this.showbackgroundColor = color;
  }
}

const globalStore = new GlobalStore();

export default globalStore;
